<template>
	<v-card>
		<v-card-title>
			Solicitações
			<v-spacer></v-spacer>
			<v-btn color="primary" small @click="novaSolicitacao">
				<v-icon left small>mdi-plus</v-icon>
				Nova
			</v-btn>
		</v-card-title>
		<v-data-table 
			:headers="headers" 
			:items="solicitacoes" 
			:loading="loading"
			dense
		>
			<template v-slot:item.tipo="{ item }">
				<v-chip x-small :color="getTipoColor(item.tipo)" dark>
					{{ item.tipo }}
				</v-chip>
			</template>
			<template v-slot:item.status="{ item }">
				<v-chip x-small :color="getStatusColor(item.status)" dark>
					{{ item.status }}
				</v-chip>
			</template>
			<template v-slot:item.data_solicitacao="{ item }">
				{{ formatoData(item.data_solicitacao) }}
			</template>
			<template v-slot:item.actions="{ item }">
				<v-btn icon x-small @click="verDetalhes(item)">
					<v-icon small>mdi-eye</v-icon>
				</v-btn>
				<v-btn v-if="canDelete(item)" icon x-small color="error" @click="confirmarRemocao(item)">
					<v-icon small>mdi-delete</v-icon>
				</v-btn>
			</template>
		</v-data-table>
		<DialogNovaSolicitacao />
		<DialogDetalhes />
		<v-dialog v-model="dialogConfirm" max-width="400">
			<v-card>
				<v-card-title class="headline">Confirmar</v-card-title>
				<v-card-text>Excluir esta solicitação?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="dialogConfirm = false">Cancelar</v-btn>
					<v-btn color="error" @click="remover">Excluir</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex'
import Bus from '@/barramento'
import moment from 'moment'
import DialogNovaSolicitacao from './DialogNovaSolicitacao.vue'
import DialogDetalhes from './DialogDetalhes.vue'

export default {
	name: 'theSolicitacoes',
	components: {
		DialogNovaSolicitacao,
		DialogDetalhes
	},
	data() {
		return {
			solicitacoes: [],
			loading: false,
			dialogConfirm: false,
			itemToDelete: null,
			headers: [
				{ text: 'ID', value: 'idsolicitacoes', width: '60px' },
				{ text: 'Funcionário', value: 'nome' },
				{ text: 'Tipo', value: 'tipo', width: '140px' },
				{ text: 'Data', value: 'data_solicitacao', width: '100px' },
				{ text: 'Status', value: 'status', width: '100px' },
				{ text: 'Ações', value: 'actions', sortable: false, width: '80px' }
			]
		}
	},
	computed: {
		...mapState(['user'])
	},
	methods: {
		async loadSolicitacoes() {
			this.loading = true
			try {
				const response = await axios.get(`${baseApiUrl}/solicitacoes`)
				this.solicitacoes = response.data
			} catch (err) {
				showError(err)
			} finally {
				this.loading = false
			}
		},
		novaSolicitacao() {
			Bus.$emit('novaSolicitacao')
		},
		verDetalhes(item) {
			Bus.$emit('loadDetalhes', item)
		},
		canDelete(item) {
			return item.status === 'Pendente' &&
				(item.funcionarios_idfuncionarios === this.user.idfuncionario ||
					['Master', 'Admin', 'Gerente'].includes(this.user.tipo))
		},
		confirmarRemocao(item) {
			this.itemToDelete = item
			this.dialogConfirm = true
		},
		async remover() {
			try {
				await axios.delete(`${baseApiUrl}/solicitacoes/${this.itemToDelete.idsolicitacoes}`)
				this.$toasted.global.defaultSuccess()
				this.loadSolicitacoes()
			} catch (err) {
				showError(err)
			} finally {
				this.dialogConfirm = false
				this.itemToDelete = null
			}
		},
		getTipoColor(tipo) {
			switch (tipo) {
				case 'Troca dia/turno': return 'blue'
				case 'Folga': return 'green'
				case 'Outros': return 'purple'
				default: return 'grey'
			}
		},
		getStatusColor(status) {
			switch (status) {
				case 'Pendente': return 'orange'
				case 'Aprovado': return 'green'
				case 'Recusado': return 'red'
				default: return 'grey'
			}
		},
		formatoData(data) {
			return data ? moment(data).format('DD/MM/YYYY') : ''
		},

	},
	mounted() {
		this.loadSolicitacoes()
		Bus.$on('reload', this.loadSolicitacoes)
	},
	beforeDestroy() {
		Bus.$off('reload', this.loadSolicitacoes)
	}
}
</script>